import { render, staticRenderFns } from "./ChatQuote.vue?vue&type=template&id=af31f936&scoped=true"
import script from "./ChatQuote.vue?vue&type=script&lang=js"
export * from "./ChatQuote.vue?vue&type=script&lang=js"
import style0 from "./ChatQuote.vue?vue&type=style&index=0&id=af31f936&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af31f936",
  null
  
)

export default component.exports